<template>
  <div>
    <div v-if="isDistanciel">
      <div v-if="accessTest">
        <template v-if="!_.isEmpty(tests)">
          <b-list-group flush>
            <b-list-group-item
              v-for="item in tests"
              :key="item.id"
              :class="
              `list-unstyled d-flex justify-content-between align-items-center pb-0 ${hasTestAlreadyInProgress} list-test text-center`
            "
            >
              <div
                :style="`background-image: url(${$helper.getImage(item.test.image.file_name)})`"
                class="list-image"
              />
              <div>
                <span class="text-primary">{{ $t('test.name') }}</span>
                <br />
                {{ item.test.label }}
              </div>
              <div>
                <span class="text-primary">{{ $t('test.module') }}</span>
                <br />
                {{ item.test.module_label || getModuleLabelFromIdTest(item.test.id) }}
              </div>
              <div v-if="$helper.canShowLanguage">
                <span class="text-primary">{{ $t('test.language') }}</span>
                <br />
                <template v-if="$helper.isLegacy">{{ item.test.language }}</template>
                <template v-else>{{ item.test.language | formatCountryCode }}</template>
              </div>
              <div v-if="$helper.hasPlayerWeb" class="text-right">
                <b-button
                  v-if="hasTestAlreadyInProgress"
                  class="disabled"
                  @click="$emit('openModal', item)"
                >{{ $t('actions.do_the_test') }}</b-button>
                <div
                  v-else-if="item.test.available_at"
                  class="text-left"
                >{{ $t('exam.available_at', {date: $helper.formatDate(item.test.available_at, 'LLL')}) }}</div>
                <bt-to-player v-else :career-id="item.id" :qs="qs">{{ $t('actions.do_the_test') }}</bt-to-player>
              </div>
            </b-list-group-item>
          </b-list-group>
        </template>
        <b-alert
          v-else-if="!hasTestAlreadyInProgress && _.isEmpty(tests)"
          variant="info"
          class="m-3"
          show
        >{{ $t("test.empty_set") }}</b-alert>
      </div>
      <div v-else>
        <div v-if="accessIntermediate">
          <div class="text-center">
            <b-button variant="outline-primary" @click="goToTests()">Accéder au test</b-button>
          </div>
          <div
            class="alert alert-danger text-center"
            v-if="isDenied"
          >Vous devez attendre que votre examinateur téléverse la copie d'écran pour accéder aux tests.</div>
        </div>
        <div v-else>
          <div class="alert alert-danger text-center">
            <span
              v-if="accessIntermediateErrorMessage == 'session_started'"
            >La session utilisant le code de déverrouillage que vous avez renseigné est déjà commencée.</span>
            <span
              v-if="accessIntermediateErrorMessage == 'session_full'"
            >Trop de candidats font déjà partie de cette session.</span>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="accessTest">
        <template v-if="!_.isEmpty(tests)">
          <b-list-group flush>
            <b-list-group-item
              v-for="item in tests"
              :key="item.id"
              :class="
              `list-unstyled d-flex justify-content-between align-items-center pb-0 ${hasTestAlreadyInProgress} list-test text-center`
            "
            >
              <div
                :style="`background-image: url(${$helper.getImage(item.test.image.file_name)})`"
                class="list-image"
              />
              <div>
                <span class="text-primary">{{ $t('test.name') }}</span>
                <br />
                {{ item.test.label }}
              </div>
              <div>
                <span class="text-primary">{{ $t('test.module') }}</span>
                <br />
                {{ item.test.module_label || getModuleLabelFromIdTest(item.test.id) }}
              </div>
              <div v-if="$helper.canShowLanguage">
                <span class="text-primary">{{ $t('test.language') }}</span>
                <br />
                <template v-if="$helper.isLegacy">{{ item.test.language }}</template>
                <template v-else>{{ item.test.language | formatCountryCode }}</template>
              </div>
              <div v-if="$helper.hasPlayerWeb" class="text-right">
                <b-button
                  v-if="hasTestAlreadyInProgress"
                  class="disabled"
                  @click="$emit('openModal', item)"
                >{{ $t('actions.do_the_test') }}</b-button>
                <div
                  v-else-if="item.test.available_at"
                  class="text-left"
                >{{ $t('exam.available_at', {date: $helper.formatDate(item.test.available_at, 'LLL')}) }}</div>
                <bt-to-player v-else :career-id="item.id" :qs="qs">{{ $t('actions.do_the_test') }}</bt-to-player>
              </div>
            </b-list-group-item>
          </b-list-group>
        </template>
        <b-alert
          v-else-if="!hasTestAlreadyInProgress && _.isEmpty(tests)"
          variant="info"
          class="m-3"
          show
        >{{ $t("test.empty_set") }}</b-alert>
      </div>
      <div v-else>
        <div class="text-center">
          <b-button variant="outline-primary" @click="goToTests()">Réessayer</b-button>
        </div>
        <div class="alert alert-danger text-center">
          <span>{{ $t('legacy.certification.has_invalid_ip') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BtToPlayer from "@/components/bt-to-player";

export default {
  name: "TestListComponent",
  components: {
    BtToPlayer,
  },
  props: {
    player: {
      type: String,
      default: null,
    },
    code: {
      type: String,
      default: null,
    },
    accessIntermediate: {
      type: Boolean,
      default: false,
    },
    isDenied: {
      type: Boolean,
      default: false,
    },
    accessTest: {
      type: Boolean,
      default: false,
    },
    isDistanciel: {
      type: Boolean,
      default: false,
    },
    accessIntermediateErrorMessage: {
      type: String,
      default: null,
    },
    tests: {
      type: Array,
      default: () => [],
    },
    hasTestAlreadyInProgress: {
      type: Boolean,
      default: false,
    },
    modulesLabel: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    qs() {
      const qs = { player: this.player, in_progress: false };

      if (this.player === this.get().enums.player.certif) {
        qs.unlock_code = this.get().code;
      }

      return qs;
    },
  },
  methods: {
    getModuleLabelFromIdTest(idtest) {
      return this.modulesLabel[idtest].label || " - ";
    },
    goToTests() {
      this.$emit("unlock", [false]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/vars";

.list-image {
  width: 25%;
  height: 80px;
  background: {
    position: center;
    repeat: no-repeat;
    size: contain;
  }
}

.disabled {
  pointer-events: all !important;

  .list-image {
    opacity: 0.6;
  }
}

.list-test > div {
  flex: 1;
}
</style>
